__turbopack_context__.v({
  "className": "L54rSq_className",
  "variable": "L54rSq_variable",
});
